import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import BlueButton from "../../BlueButton/BlueButton.js";
import {word} from '../../../word.js'
import {managerUpdateRequest} from "../../../store/actions/manager.js";


const Name = ({ close, showSettings }) => {
    const [name, setName] = useState("");
    const [submit, setSubmit] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const login = useSelector((state) => state.manager.employee);
    const dispatch = useDispatch();

    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submitForm();
        }
    };

    const submitForm = async () => {
        setSubmit(true);

        if (name.length < 3) return;

        setDisabled(true);
        let formData = new FormData();
        if (showSettings !== "surname") {
            formData.append("user.first_name", name);
            formData.append("user.last_name", login.user.last_name);
            formData.append("user.email", login.user.email);
        } else {
            formData.append("user.first_name", login.user.first_name);
            formData.append("user.last_name", name);
            formData.append("user.email", login.user.email);
        }

        await dispatch(managerUpdateRequest({form:formData,id: login.id, }));
        close();

    };

    return (
        <div className="settings-item">
            <Form.Group className="justify-content-center form-group">
                <Form.Control
                    placeholder={showSettings ? "Ազգանուն" : "Անուն"}
                    className={name.length < 3 && submit ? "form-control is-invalid" : "form-control"}
                    autoComplete="off"
                    onKeyDown={keyPress}
                    onChange={(e) => setName(e.target.value)}
                />
                {name.length < 3 && submit && (
                    <div className="validation valid-center">
                        <span>{word.name_error}</span>
                    </div>
                )}
            </Form.Group>

            <BlueButton disabled={disabled} onChangeValue={submitForm} title="Հաստատել" />
        </div>
    );
};

export default Name;
